import { Component, ViewChild, ChangeDetectorRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisUiService } from './../../../core/service/base/his-ui.service';
import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldBase } from '../../model/field-base';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';

import { YesNoSelectComponent } from './yesnoselect.component';
import { TextAreaComponent } from './text-area.component';
import { HisDynamicContainerComponent } from './dynamic-container.component';
import { UntypedFormGroup } from '@angular/forms';
import { tap } from 'rxjs/operators';

@Component( {
    template: `
        <p-panel header="{{ label }}" [hisDdKey]="config.ddKey">
            <his-dynamic-container (readyToUse)="containerDone()" [dynamicFieldConfig]="config"></his-dynamic-container>
        </p-panel>
      `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class YesNoWithTextAreaComponent extends HisDynamicFieldBase<string> {
    private changeDetectorRef = inject(ChangeDetectorRef);

    @ViewChild( HisDynamicContainerComponent )
        dynamicContainerComponent: HisDynamicContainerComponent;
    config: HisDynamicFieldConfig;
    label = '';
    localFormGroup: UntypedFormGroup;
    yesNo: YesNoSelectComponent;
    textArea: TextAreaComponent;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);
        const hisUi = inject(HisUiService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.config = injectedData.options;
        this.label = hisUi.translate( this.config.label );
    }

    containerDone() {
        this.changeDetectorRef.detectChanges();
        this.localFormGroup = this.dynamicContainerComponent.form;
        this.formGroup.registerControl( this.name, this.localFormGroup );
        this.valueGroup.registerDynamicField( this, this.dynamicContainerComponent.valueGroup.nameOfChangedField );
        this.yesNo = this.dynamicContainerComponent.valueGroup
            .getFirstByType( YesNoSelectComponent ) as YesNoSelectComponent;
        this.textArea = this.dynamicContainerComponent.valueGroup
            .getFirstByType( TextAreaComponent ) as TextAreaComponent;
        this.yesNo.valueChangeEvent.pipe(
            tap( state => state == null ? this.textArea?.setRequired( false ) : this.textArea?.setRequired( !state ) )
        ).subscribe();
    }

    reset() {
        this.dynamicContainerComponent.resetDynamicForm();
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ): void {
        this.dynamicContainerComponent.updateConfiguration( entireFormConfig );
    }

    getControlValue(): any {
        return this.dynamicContainerComponent.getJson();
    }
}
